import { api } from 'api'
import { path } from 'ramda'
import { QuizPage, TutorialPage } from 'components/profile/Tutorials/types'

export interface CompanyTutorial {
  id: number
  name: string
  content: TutorialPage[]
  quiz: QuizPage[]
}

export async function getCompanyTutorials() {
  const data = await api.post(
    '/company/graphql_dispatch/company_tutorials_09abca51',
    {}
  )

  return path(['data', 'data', 'company', 'tutorials'], data).map(
    (tutorial) => ({
      ...tutorial,
      content: tutorial.content ? JSON.parse(tutorial.content) : [],
      quiz: tutorial.quiz ? JSON.parse(tutorial.quiz) : [],
    })
  ) as CompanyTutorial[]
}
